import React from 'react';
import PropTypes from 'prop-types';
import InnerHTML from '@Components/InnerHTML';
import { Card } from '@els/els-react--card';
import { ButtonWithIcon } from '@els/els-react--button';
import Slugify from '@Utils/Slugify';

import './SubstanceMoreNamesInformation.scss';

const MORE_NAMES_HEADING = 'More names';

function SubstanceMoreNamesInformation({ substance, onToggle }) {
  const { details } = substance;
  const { chemicalNames, chemicalNameSynonyms } = details;

  const firstName = chemicalNames?.[0];
  const otherNames = chemicalNameSynonyms?.join('; ');
  const panelIdSuffix = Slugify(substance?.index ?? details.id ?? firstName ?? MORE_NAMES_HEADING);
  const headingId = `substance-more-names-information-heading-${Slugify(firstName || MORE_NAMES_HEADING)}-${panelIdSuffix}`;

  return (
    <div
      id={`substance-more-names-information-${panelIdSuffix}`}
      className="substance-results-information u-els-font-size-base u-els-line-height-default">
      <Card
        className="substance-fact-details-card substance-alternative-information-card substance-more-names-information-card"
        heading={
          <div className="substance-fact-details-card__header">
            <h3 id={headingId} className="substance-fact-details-card__title">
              {MORE_NAMES_HEADING}
            </h3>
            <ButtonWithIcon
              data-e2e="substance-more-names-information-close"
              type="borderless"
              size="small"
              sprite="Close"
              iconRight
              iconOnly
              className="substance-fact-details-card__close"
              aria-label={`Close ${MORE_NAMES_HEADING}`}
              onClick={onToggle}>
              Close {MORE_NAMES_HEADING}
            </ButtonWithIcon>
          </div>
        }
        headingLevel="h3"
        // RX-23573: no `role="region"` — per-result panel landmark overuse (ARIA APG). `<h3>` heading retained.
        aria-labelledby={headingId}>
        {firstName && <InnerHTML tag="div" html={firstName} mode="escape" />}
        {otherNames && <InnerHTML tag="div" className="rx-substance-identification u-els-margin-top-1o4" html={otherNames} mode="escape" />}
      </Card>
    </div>
  );
}

SubstanceMoreNamesInformation.propTypes = {
  substance: PropTypes.object.isRequired,
  onToggle: PropTypes.func.isRequired,
};

export default SubstanceMoreNamesInformation;
